import React from 'react'
import logo from "../../Assets/Images/logo.png"
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./Footer.scss"
import { Link } from "react-router-dom"

const Footer = () => {
  return (
    <div>
      <footer>
        <div id="ul-footer-area" className="ul-footer-area mt-70 pt-50 pb-10">
          <div className="row">
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay=".5s"
            >
              <div className="footer-single-wedget">
                <div className="custom-html-widget">
                  <img src={logo} alt="logo" />
                  {/* <h3>newsletter</h3> */}
                  <p>
                    Our core mission is to improve patient outcomes through innovation and a commitment to excellence.
                  </p>

                </div>
              </div>
            </div>

            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay=".2s"
            >
              <div className="footer-single-wedget">
                <div className="widget_nav_menu">
                  <h3>quick links</h3>
                  <ul className="menu">
                    <li> <Link to={"/"}>home</Link></li>

                    <li><Link to={"/about"}>about us</Link></li>

                    <li>
                      <Link to={"/product-range"}>
                        Product Range
                      </Link>
                    </li>
                    <li>
                      <Link to={"/contact"}>
                        Contact Us
                      </Link>
                    </li>
                    {/* <li>
                      <a href="#">privacy policy</a>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="col-xl-4 col-lg-4 col-md-6 col-sm-12 wow fadeInRight"
              data-wow-delay=".4s"
            >
              <div className="footer-single-wedget">
                <div className="custom-html-widget">
                  <h3>contact us</h3>
                  <ul className="contact-details">
                    <li>
                      <i className="fa-solid fa-phone"></i>
                      <a href="tel:919825966404"><p>+91-9825966404</p></a>
                    </li>
                    <li>
                      <i class="fa-solid fa-envelope"></i>
                      <a href="mailto:gsslifesciences@gmail.com"> <p>gsslifesciences@gmail.com</p></a>
                    </li>
                    <li>
                      <div>
                        <i className="fa-solid fa-location-dot"></i>
                      </div>
                      <a href="https://www.google.com/maps/place/Vadvali+Mehta+Pole/@23.037389,72.579648,16z/data=!4m6!3m5!1s0x395e8534399d8e91:0x74e710d0ac8e1878!8m2!3d23.037389!4d72.579648!16s%2Fg%2F11pwvgh_8p?hl=en&entry=ttu&g_ep=EgoyMDI1MDQyMy4wIKXMDSoASAFQAw%3D%3D"><p>3158, Vadwali Mehta Pole, Shahpur,
                        Ahmedabad, Gujarat, 380001</p></a>
                    </li>

                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ul footer copyright area start */}
        <div className="ul-copyright-area">
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12">
                <div className="footer-copyright text-center ">
                  <p>
                    © 2025 All rights reserved by{" "}
                    <a href="#" target="_blank">
                      GSS Life Sciences
                    </a>
                  </p>
                  <p>
                    Designed by{" "}
                    <a href="https://ahsassuredservices.com/web_design_and_development" target="_blank">
                      AHS
                    </a>
                  </p>
                  <div className="flex-grow-1" />

                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ul footer copyright area end */}
      </footer>

    </div>
  )
}

export default Footer